import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

export const FormLabel = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2),
  width: '160px',
  display: 'inline-block',
  flexShrink: 0,
}))
